const getTopics = (state) =>
  state.topic.builtInTopics.concat(state.topic.deviceTopics).concat(state.topic.appTopics);

export { getTopics };
